import React from "react";

interface OrpPopupProps {
  name: string;
  language: 'cz' | 'en'; // ⬅️ tu si ho berieme ako prop
  seasonStart: { date: string | null; doy: number | null };
  seasonEnd: { date: string | null; doy: number | null };
  seasonLength: number | null;
  checkedItems: {
    vegetationSeason?: boolean;
    vegetationSeasonEnd?: boolean;
    seasonLength?: boolean;
  };
}

const OrpPopup: React.FC<OrpPopupProps> = ({
  name,
  language,
  seasonStart,
  seasonEnd,
  seasonLength,
  checkedItems,
}) => {
  const translations = {
    cz: {
      start: "Začátek sezony",
      end: "Konec sezony",
      length: "Délka sezony",
      days: "dní",
    },
    en: {
      start: "Start of season",
      end: "End of season",
      length: "Season length",
      days: "days",
    },
  }[language];

  return (
    <div style={{ maxWidth: "250px", fontSize: "14px", lineHeight: "1.4" }}>
      <strong style={{ fontSize: "16px" }}>{name}</strong>

      {checkedItems.vegetationSeason && seasonStart.date && (
        <p>
          <strong>{translations.start}:</strong> {seasonStart.date} (DOY: {seasonStart.doy})
        </p>
      )}

      {checkedItems.vegetationSeasonEnd && seasonEnd.date && (
        <p>
          <strong>{translations.end}:</strong> {seasonEnd.date} (DOY: {seasonEnd.doy})
        </p>
      )}

      {checkedItems.seasonLength && seasonLength !== null && (
        <p>
          <strong>{translations.length}:</strong> {seasonLength} {translations.days}
        </p>
      )}
    </div>
  );
};

export default OrpPopup;
